<template>
  <div class="header-box" :class="{'header-fixed': isPageScroll}">
    <div class="header-con" :class="{'nav-dark': headColor === 'dark','nav-light': headColor === 'light'}">
      <!-- logo -->
      <div class="logo">
        <img v-if="headColor === 'dark'" src="../../assets/img/header/logo.png">
        <img v-if="headColor === 'light'" src="../../assets/img/header/logo-white.png" >
        <div class="stockBox">
          <span>股票名称：金现代</span>
          <span>股票代码：300830</span>
        </div>
      </div>
      <!-- 导航 -->
      <div class="navigator">
        <div :class="{'isActive':router===''}" @click="jumpTo('/')" class="navigatorLeft"  style="width: 83px;">PaaS平台</div>
        <div :class="{'isActive':router.indexOf('Product') > -1}" @mouseover="fixedBody" @mouseout="removeFixed" class="navigatorLeft" >
          <span>产品中心</span>
          <section class="product-nav" @mouseover="fixedBody" @mouseout="removeFixed">
            <div class="productNav">
              <div class="product-nav-list product-nav-list-width">
                <div class="product-nav-list-header">
                  <img src="../../assets/img/header/select-title1.png">
                  低代码PaaS平台产品矩阵
                </div>
                <div class="product-nav-list-line product-nav-list-width"></div>
                <div style="display: flex">
                  <div>
                    <div class="product-nav-list-content" @click="jumpTo('/nocode')">
                      <div class="product-nav-content-title">
                        零代码开发平台
                        <img class="product-nav-hot" src="../../assets/img/header/select-hot.png">
                      </div>
                      <div class="product-nav-content-desc">
                        适用于业务人员的高效、便捷的开发工具，会使用office就会编程。
                      </div>
                    </div>
                    <div class="product-nav-list-content" @click="jumpTo('/lowcode')">
                      <div class="product-nav-content-title">
                        低代码开发平台
                        <img class="product-nav-hot" src="../../assets/img/header/select-hot.png">
                      </div>
                      <div class="product-nav-content-desc">
                        成熟、稳定、专业的低代码开发平台，让软件开发更简单。
                      </div>
                    </div>
                  </div>
                  <div style="margin-left: 20px">
                    <div class="product-nav-list-content" @click="jumpTo('/apaas')">
                      <div class="product-nav-content-title">
                        融合集成平台
                      </div>
                      <div class="product-nav-content-desc">
                        采用标准化的集成方式，为企业数字化转型提供集成能力。
                      </div>
                    </div>
                    <div class="product-nav-list-content" @click="jumpTo('/portal')">
                      <div class="product-nav-content-title">
                        统一门户平台
                      </div>
                      <div class="product-nav-content-desc">
                        为用户提供便利的一站式访问体验，提高工作效率。
                      </div>
                    </div>
                    <div class="product-nav-list-content" @click="jumpTo('/bpm')">
                      <div class="product-nav-content-title">
                        工作流平台
                      </div>
                      <div class="product-nav-content-desc">
                        流程快速开发和运维，为企业流程业务和管理决策提供支撑。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-nav-list product-nav-list-width">
                <div class="product-nav-list-header">
                  <img src="../../assets/img/header/select-title4.png">
                  关键特性
                </div>
                <div class="product-nav-list-line product-nav-list-width"></div>
                <div style="display: flex">
                  <div>
                    <div class="product-nav-list-content" @click="jumpTo('/keyfeatures','#visualDevelopment')">
                      <div class="product-nav-content-title">
                        可视化开发
                      </div>
                      <div class="product-nav-content-desc">
                        可视化管理工具提供可视化构建能力，有效缩短研发周期。
                      </div>
                    </div>
                    <div class="product-nav-list-content" @click="jumpTo('/keyfeatures','#aiAbility')">
                      <div class="product-nav-content-title">
                        AI能力
                      </div>
                      <div class="product-nav-content-desc">
                        人工智能融入到低代码开发，助力企业从数字化到数智化。
                      </div>
                    </div>
                    <div class="product-nav-list-content" @click="jumpTo('/keyfeatures','#comprehensive')">
                      <div class="product-nav-content-title">
                        全面信创
                      </div>
                      <div class="product-nav-content-desc">
                        支持国产化服务器、操作系统、中间件、数据库。
                      </div>
                    </div>
                    <div class="productNav-all" @click="jumpTo('/allproduct')">查看所有产品 ></div>
                  </div>
                  <div style="margin-left: 20px">
                    <div class="product-nav-list-content" @click="jumpTo('/keyfeatures','#expand')">
                      <div class="product-nav-content-title">
                        灵活扩展
                      </div>
                      <div class="product-nav-content-desc">
                        平台支持多种二次扩展方式，实现复杂业务需求。
                      </div>
                    </div>
                    <div class="product-nav-list-content" @click="jumpTo('/keyfeatures','#security')">
                      <div class="product-nav-content-title">
                        安全可靠
                      </div>
                      <div class="product-nav-content-desc">
                        产品按等保、分保测评的标准建设，安全可靠。
                      </div>
                    </div>
                    <div class="product-nav-list-content" @click="jumpTo('/keyfeatures','#singleService')">
                      <div class="product-nav-content-title">
                        单体/微服务双架构
                      </div>
                      <div class="product-nav-content-desc">
                        双架构模式，满足用户的个性化需求。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="product-nav-list">
                <div class="product-nav-list-header">
                  <img src="../../assets/img/header/select-title5.png">
                  支撑体系
                </div>
                <div class="product-nav-list-line"></div>
                <div style="margin-top: 30px">
                  <div class="product-nav-list-content product-nav-list-content-no">
                    <div class="product-nav-content-title">
                      UI设计规范
                    </div>
                    <div class="product-nav-content-desc">
                      用于指导设计师创建一致、易用和高质量的用户界面。
                    </div>
                  </div>
                  <div class="product-nav-list-content product-nav-list-content-no">
                    <div class="product-nav-content-title">
                      交付能力
                    </div>
                    <div class="product-nav-content-desc">
                      团队拥有卓越的交付能力，确保项目按时高质量完成。
                    </div>
                  </div>
                  <div class="product-nav-list-content product-nav-list-content-no">
                    <div class="product-nav-content-title">
                      定制化服务
                    </div>
                    <div class="product-nav-content-desc">
                      提供定制化服务，满足您的个性化需求，为您创造独特而富有价值的解决方案。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div :class="{'isActive':router.indexOf('/CasePage') > -1}" @click="jumpTo('/CasePage')">案例</div>
        <div :class="{'isActive':router.indexOf('/DocumentPage') > -1}" @click="jumpTo('/DocumentPage')">文档</div>
        <div :class="{'isActive':router.indexOf('/FrontierPage') > -1}" @click="jumpTo('/FrontierPage')">前沿</div>
        <div :class="{'isActive':router.indexOf('/MallPage') > -1}" @click="jumpTo('/MallPage')">商城</div>
        <div @click="toLink">关于</div>
      </div>
      <!-- 按钮 -->
      <div class="btn">
        <div class="btn-experience"  @click="openForm">立即体验</div>
      </div>
      <!-- 电话 -->
      <div class="tel">
        <img v-if="headColor === 'dark'" src="../../assets/img/header/tel.png" width="17" height="17" >
        <img v-if="headColor === 'light'" src="../../assets/img/header/tel-white.png" width="17" height="17">
        <span>400-600-7966</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Header',
  props: {
    isPageScroll: {
      type: Boolean,
      default: false,
    },
    router:{
      type:String,
      default:'',
    },
    headColor: {
      type:String,
      default: 'dark',
    }
  },
  watch:{
  },
  data() {
    return {
      path: this.$route.path,
      timeoutId: null
    };
  },
  components: {
  },
  methods: {
    // 打开表单
    openForm() {
      const self = this;
      self.$emit('openForm');
    },
    // 跳转页面
    jumpTo(page,id) {
      document.body.style.cssText += `overflow: hidden auto;`;
      const self = this;
      if(id!=null){
        self.$router.push({ path: page,query:{name:id}});
      }else {
        self.$router.push({ path: page});
      }

    },
    // 打开公司官网
    toLink() {
      window.open("http://www.jxdinfo.com");
    },
    fixedBody() {
      document.body.style.cssText += `overflow: hidden;`
      clearTimeout(this.timeoutId); // 清除之前的延迟
    },
    removeFixed() {
      document.body.style.cssText += `overflow: hidden auto;`;
/*      this.timeoutId = setTimeout(() => {
        $('.header-box').css('background','rgba(255, 255, 255, 0.2)') // 恢复初始背景色
      }, 500); // 设置延迟时间，单位为毫秒*/
    }
  },
  mounted(){
  }
}
</script>
<style scoped>
.header-box {position: absolute;width: 100%;height: 80px;background: rgba(255, 255, 255, 0.2);}
/*.header-box:hover{background: #ffffff;}*/
.header-fixed {position: fixed;background: rgba(255, 255, 255, 1);z-index: 999;backdrop-filter: blur(30px);/* 背景模糊 */}
.header-con {width: 1200px;height: 100%;margin: 0 auto;font-weight: 400;}
.header-con > div {height: 100%;display: flex;align-items:center;color: #2E2E2E;}
/* logo */
.logo {float: left;width: 230px;height: 100%;justify-content: space-between;}
.logo .stockBox span {display: block;line-height: 17px;}
.logo img{height: 41px}
/* 导航 */
.navigator {float: left;display: flex;justify-content: space-between;width: calc(100% - 650px);margin-left: 80px;font-size: 18px;line-height: 16px;}

.navigator > div:hover, .navigator .isActive{position: relative;color: #186CF5;font-weight: bold;cursor: pointer;}
.navigator .isActive::after{display: block;position: absolute;top: 46px;left: 8px;width: 16px; height: 2px; background: #186CF5;content: '';}
.navigator .navigatorLeft::after {left: 30px!important;}
.nav-dark div, .nav-dark div a {color: #2e2e2e}
.nav-light div, .nav-light div a, .nav-light span {color: #fff}
.tel, .btn {float: right;}
.btm-line{position: relative;bottom: 0;display: block;width: 0;height: 3px;margin: -3px auto;background: #3d91ff;transition: all .5s ease;}
/* 电话 */
@-webkit-keyframes shake {
  10% {transform: rotate(20deg);}
  20% {transform: rotate(-20deg);}
  30% {transform: rotate(5deg);}
  40% {transform: rotate(-5deg);}
  50%, 100% {transform: rotate(0deg);}
}
.tel span {margin-left: 5px;font-size: 18px;line-height: 16px;}
.tel img {animation: shake 1s 0.15s linear infinite;
  -moz-animation: shake 1s 0.15s linear infinite; /* Firefox */
  -webkit-animation: shake 1s 0.15s linear infinite; /* Safari and Chrome */
  -o-animation: shake 1s 0.15s linear infinite; /* Opera */
}
/* 按钮 */
.btn {margin-left: 30px;}
.btn .btn-experience {width: 100px;height: 38px;background: #f19f35;border-radius: 5px;font-size: 16px;color: #FFF;line-height: 38px;text-align: center;}
.btn-experience:hover {background: #F3C715;}
.navigatorLeft .product-nav {width: 100%;height: 0;left: 0;top:80px;position: fixed;background: #ffffff;transition: height .5s;z-index: 10;cursor: default;box-shadow: 0 20px 20px rgba(0, 47, 126, .12);}
/*使不同分辨率下视觉效果大致相同*/
 @media screen and (min-width: 1910px) {
   .navigatorLeft:hover .product-nav {height: 500px;}
}
@media screen and (max-width: 1900px) and (min-width: 1601px) {
  .navigatorLeft:hover .product-nav {height: calc(500px);}
}
@media screen and (max-width: 1600px) {
  .navigatorLeft:hover .product-nav {height: calc(500px);}
}
.navigatorLeft .is-active .product-nav {font-weight: 400;}

.productNav {width: 1200px;height: 100%;overflow-y: auto;cursor: default;margin: 5px auto auto;background: url("../../assets/img/header/select-bg.png") no-repeat;background-size: 100% 100%;display: flex;overflow: hidden;padding: 0px 25px;}
.product-nav-list{width: 208px;margin:20px 15px 0px 11px;}
.product-nav-list-width{width: 440px !important;}
.product-nav-list-header{background: url("../../assets/img/header/select-title-bg.png") no-repeat;background-size: 100% 100%;width: 100%;height: 45px;color: #686868 !important;font-size: 16px;font-weight: normal;padding: 9px 14px;line-height: 15px;}
.product-nav-list-header img{margin-right: 5px;position: relative;top: 4px;font-weight: bold;}
.product-nav-list-line{width: 208px;height: 0px;border-top: 1px solid #186CF5;opacity: 0.15;margin: 5px 0px 20px 0px;}
.product-nav-list-content{margin:10px 3px 30px 3px;cursor: pointer;}
.product-nav-content-title{font-weight: normal;font-size: 16px;color: #333333 !important;margin-bottom: 10px;font-weight: bold;}
.product-nav-list-content:hover .product-nav-content-title{color: #186CF5 !important;}
.product-nav-list-content-no{cursor: unset;}
.product-nav-list-content-no:hover .product-nav-content-title{color: #2e2e2e !important;}
.product-nav-content-desc{font-weight: 400;font-size: 14px;color: #9C9C9C !important;line-height: 20px;text-align: justify;}
.productNav-all{position: relative;color: #186CF5 !important;font-size: 16px;top: 50px;left:50px;font-weight: bold;cursor: pointer;}
.productNav-all:hover{color: #186CF5 !important;}
</style>



// WEBPACK FOOTER //
// src/components/include/Header.vue